import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { checkActionCredits } from "@/api/endpoints/credits";
import { queryKeys } from "@/lib/queryClient";
import type {
  CheckActionCreditsRequest,
  CheckActionCreditsResponse,
} from "@/api/types/credits";

export type UseCheckActionCreditsResult = UseQueryResult<
  CheckActionCreditsResponse,
  Error
> & {
  hasInsufficientCredits: boolean;
};

export function useCheckActionCredits(
  request: CheckActionCreditsRequest,
  enabled?: boolean
): UseCheckActionCreditsResult {
  const query = useQuery({
    queryKey: queryKeys.credits.checkAction(
      request.session_id,
      request.action_type
    ),
    queryFn: () => checkActionCredits(request),
    staleTime: 1000 * 30,
    enabled: enabled,
  });

  const hasInsufficientCredits =
    !!query.data && !query.data.has_credits && !query.data.already_purchased;

  return Object.assign(query, { hasInsufficientCredits });
}
